import { render } from "./ShowSelectionDropdown.vue?vue&type=template&id=1a63b524&scoped=true"
import script from "./ShowSelectionDropdown.vue?vue&type=script&lang=js"
export * from "./ShowSelectionDropdown.vue?vue&type=script&lang=js"

import "./ShowSelectionDropdown.vue?vue&type=style&index=0&id=1a63b524&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a63b524"]])

export default __exports__